import React from 'react';
import { WhatsappLogo } from '@phosphor-icons/react';
import { BRAND } from '@/theme/brand';

const WhatsAppFloat = () => {
  const message = encodeURIComponent('Hello! I would like to book a cab with ATITHI Travel.');

  return (
    <a
      href={`https://wa.me/${BRAND.contact.phone}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-16 md:bottom-7 right-7 z-[9999] flex items-center justify-center gap-2 rounded-full bg-[#25D366] text-white text-sm font-bold shadow-[0_4px_20px_rgba(37,211,102,0.4)] hover:scale-105 hover:shadow-xl transition-all duration-200 p-4 md:px-4 md:py-3"
      data-testid="whatsapp-float"
    >
      <WhatsappLogo size={24} weight="fill" className="shrink-0" />
      <span className="hidden sm:inline">Chat with us</span>
    </a>
  );
};

export default WhatsAppFloat;
